import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = ({ activities }) => {
  const navigate = useNavigate();

  const getActivityIcon = (type) => {
    const icons = {
      prediction: 'Target',
      tournament_join: 'UserPlus',
      tournament_leave: 'UserMinus',
      points_earned: 'Award',
      rank_change: 'TrendingUp',
      match_result: 'CheckCircle'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      prediction: 'var(--color-accent)',
      tournament_join: 'var(--color-primary)',
      points_earned: 'var(--color-success)',
      rank_change: 'var(--color-warning)',
      match_result: 'var(--color-secondary)'
    };
    return colors?.[type] || 'var(--color-muted-foreground)';
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffMs = now - activityTime;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) {
      return `${diffMins}m ago`;
    } else if (diffHours < 24) {
      return `${diffHours}h ago`;
    } else {
      return `${diffDays}d ago`;
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg md:text-xl font-semibold text-foreground">Recent Activity</h2>
        <button 
          onClick={() => navigate('/notifications')}
          className="text-xs md:text-sm text-primary hover:text-primary/80 transition-smooth font-medium flex-shrink-0"
        >
          View All
        </button>
      </div>
      <div className="space-y-2.5">
        {activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Activity" size={40} className="mx-auto mb-3 text-muted-foreground opacity-50" />
            <p className="text-sm text-muted-foreground">No recent activity yet</p>
            <p className="text-xs text-muted-foreground mt-1">Join tournaments and make predictions to see your activity here</p>
          </div>
        ) : (
          activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start gap-2.5 md:gap-3 p-2.5 md:p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-smooth">
              <div
                className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center"
                style={{ backgroundColor: `${getActivityColor(activity?.type)}15` }}
              >
                <Icon name={getActivityIcon(activity?.type)} size={18} color={getActivityColor(activity?.type)} />
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-xs md:text-sm text-foreground mb-1 break-words">
                  {activity?.description}
                </p>
                <div className="flex items-center gap-1.5 text-[10px] md:text-xs text-muted-foreground">
                  <Icon name="Clock" size={12} className="flex-shrink-0" />
                  <span>{formatTimeAgo(activity?.time)}</span>
                </div>
              </div>

              {activity?.points && (
                <div className="flex-shrink-0 px-2 py-0.5 bg-success/10 rounded-full">
                  <span className="text-[10px] md:text-xs font-semibold text-success">+{activity?.points}</span>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecentActivityFeed;